// Lightweight global fetch interceptor to
// - attach Authorization header for same-origin /api calls
// - redirect to /login on 401 and clear session

export function installFetchInterceptor() {
  if (typeof window === 'undefined' || !(window as any).fetch) return;
  const origFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    try {
      const url = typeof input === 'string' ? input : (input as Request).url;
      const isApi = url.startsWith('/api') || url.startsWith(window.location.origin + '/api');
      const isAuthPath = url.includes('/api/auth/login') || url.includes('/api/auth/register');

      // Clone init to avoid mutating caller's object
      const nextInit: RequestInit = { ...(init || {}) };
      nextInit.headers = new Headers(nextInit.headers as HeadersInit);

      // Attach bearer token if not already present
      if (isApi && !isAuthPath) {
        const h = nextInit.headers as Headers;
        const hasAuth = h.get('Authorization');
        const token = localStorage.getItem('token');
        if (!hasAuth && token) h.set('Authorization', `Bearer ${token}`);
      }

      const res = await origFetch(input as any, nextInit);

      if (res.status === 401) {
        try {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        } catch {}
        if (!window.location.pathname.startsWith('/login')) {
          window.location.replace('/login');
        }
      }

      return res;
    } catch (err) {
      // In case of unexpected errors, still bubble up
      throw err;
    }
  };
}


